import iconBaseball from "../../../../assets/icon_baseball3.svg";
import iconReset from "../../../../assets/icon_reset.svg";

const LandersIntroButton = ({ children, onClick }) => {
  return (
    <button
      className="fixed left-3.5 w-20 h-14 bottom-[5rem] flex flex-col items-center justify-center gap-1"
      onClick={onClick}
    >
      <span>
        <img src={iconBaseball} alt="" className="w-20 h-20"/>
      </span>
      <span className="fixed left-4.5 bottom-[6.5rem] px-2 rounded-xl">
        <img src={iconReset} alt="" />
      </span>
      <span className="opacity-[80%] fixed left-4.5 bottom-[5rem] bg-brand-point px-2 rounded-xl">
        <div className="text-[12px] font-semibold text-neutral-700">{children}</div>
      </span>
    </button>
  );
};

export default LandersIntroButton;
